const serviceDomain = process.env.NEXT_PUBLIC_WEB_SERVICES_DOMAIN;
const siteUrl = process.env.NEXT_PUBLIC_SITE_URL;

export const AMCApiEndpoints = {
  AMC_CONTENT: `${siteUrl}/content/bajajfinserv/bajajfinserv-web/{version}/en/all-products/bajaj-amc/pdp/sch-name.headless.json`,
  AMC_DETAILS: `${serviceDomain}/api/mf/v2/schemedetails`,
  AMC_SIMILAR_SCHEMES: `${serviceDomain}/api/v2/similarschemes`,
  AMC_TOP_FUNDS_HOLDING: `${serviceDomain}/api/mf/v2/schemeholdings`,
  AMC_SECTOR_FUNDS_HOLDING: `${serviceDomain}/api/v2/schemesectors`,
  AMC_CHART: `${serviceDomain}/api/v2/mutual-funds-chart-list`,
  INITIAL_LISTING_DATA: `${serviceDomain}/api/v2/mutual-funds/initial-listing-data`,
};
